import { Plus } from 'lucide-react';
import { BLOCK_SCHEMAS } from './blocks';
import type { BlockType } from '@shared/types';

interface Props {
  onAdd: (type: BlockType) => void;
  onDragStartLibrary?: () => void;
}

export default function BlockLibrary({ onAdd, onDragStartLibrary }: Props) {
  return (
    <div className="w-56 border-r border-slate-200 bg-slate-50 flex-shrink-0 overflow-y-auto">
      <div className="px-4 py-3 border-b border-slate-200 sticky top-0 bg-slate-50 z-10">
        <div className="text-xs font-semibold uppercase tracking-wide text-slate-500">Blocks</div>
        <div className="text-[11px] text-slate-400 mt-0.5">Drag in or click +</div>
      </div>
      <div className="p-2 space-y-1">
        {(Object.entries(BLOCK_SCHEMAS) as [BlockType, typeof BLOCK_SCHEMAS[BlockType]][]).map(([key, schema]) => {
          const Icon = schema.icon;
          return (
            <div
              key={key}
              draggable
              onDragStart={(e) => {
                e.dataTransfer.effectAllowed = 'copy';
                e.dataTransfer.setData('text/plain', JSON.stringify({ kind: 'new', blockType: key }));
                onDragStartLibrary?.();
              }}
              onDragEnd={() => onDragStartLibrary?.()}
              className="group flex items-center gap-2 p-2 rounded-md hover:bg-white hover:shadow-sm cursor-grab active:cursor-grabbing border border-transparent hover:border-slate-200 transition-all"
              onClick={() => onAdd(key)}
            >
              <div className="w-7 h-7 rounded-md bg-white border border-slate-200 flex items-center justify-center flex-shrink-0 group-hover:border-blue-300 group-hover:bg-blue-50">
                <Icon size={13} className="text-slate-600 group-hover:text-blue-700" />
              </div>
              <div className="min-w-0 flex-1">
                <div className="text-xs font-semibold text-slate-800 truncate">{schema.label}</div>
                <div className="text-[10px] text-slate-500 truncate leading-tight">{schema.description}</div>
              </div>
              <Plus size={12} className="text-slate-300 group-hover:text-blue-600 flex-shrink-0" />
            </div>
          );
        })}
      </div>
    </div>
  );
}
